import { Image, TOPBAR_HEIGHT } from '@capsicum/common-web';
import { HeaderWarning } from '@capsicum/features/regulations/web';
import styled from 'styled-components';

export const Wrapper = styled.div<{ $isDisplayButton: boolean }>`
	display: flex;
	flex: 1;
	flex-direction: column;
	padding: ${({ theme }) => `${theme.spacings.xxlarge} 0`};
	gap: ${({ theme }) => theme.spacings.large};

	${({ theme }) => theme.breakpoints.queries.below.tabletSmallDesktop} {
		padding: ${({ $isDisplayButton, theme }) =>
			`${theme.spacings.small} ${theme.spacings.small} ${
				$isDisplayButton ? theme.spacings.xxxlarge : theme.spacings.small
			}`};
	}
`;

export const Title = styled.span`
	${({ theme }) => theme.fonts.headings.title5};
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const MainContainer = styled.div`
	display: flex;
	gap: ${({ theme }) => theme.spacings.small};
	padding: ${({ theme }) => theme.spacings.small};
	background-color: ${({ theme }) => theme.colors.backgrounds.main.container};
	${({ theme }) => theme.border.radius.medium};

	${({ theme }) => theme.breakpoints.queries.below.mobile} {
		flex-direction: column;
	}
`;

export const ImageWrapper = styled.div`
	position: relative;
	display: flex;
	flex: 1 0 0;
	justify-content: center;
	height: 303px;

	${({ theme }) => theme.breakpoints.queries.below.mobile} {
		flex-direction: column;
		flex: auto;
	}
`;

export const MainImage = styled(Image)`
	object-fit: contain;
	align-self: center;
`;

export const PoweredMws = styled(Image)`
	position: absolute;
	bottom: ${({ theme }) => theme.spacings.small};
	right: ${({ theme }) => theme.spacings.xxsmall};
`;

export const SerieAlogoWrapper = styled.div`
	position: absolute;
	bottom: ${({ theme }) => theme.spacings.small};
	right: ${({ theme }) => theme.spacings.xxsmall};
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const PoweredByText = styled.span`
	${({ theme }) => theme.fonts.text.text5};
	margin-bottom: ${({ theme }) => theme.spacings.xxxsmall};
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const StyledCardImagePlaceholder = styled.div`
	flex: 1 0 0;
	height: 303px;
	background-color: ${({ theme }) => theme.colors.skeleton.default};

	${({ theme }) => theme.breakpoints.queries.below.mobile} {
		flex: auto;
	}
`;

export const Content = styled.div`
	display: flex;
	flex: 1 0 0;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacings.small};
`;

export const HeaderWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	gap: ${({ theme }) => theme.spacings.xxsmall};
`;

export const AuctionUkHeaderWarning = styled(HeaderWarning)`
	background-color: ${({ theme }) => theme.colors.backgrounds.main.container};
	top: ${TOPBAR_HEIGHT + 8}px;
`;

export const EventContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex-shrink: 1;
	width: 70%;
`;

export const Event = styled.span`
	${({ theme }) => theme.fonts.text.caption1};
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const Player = styled.span`
	${({ theme }) => theme.fonts.headings.title6};
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const GoalBy = styled.span`
	color: ${({ theme }) => theme.colors.text.main.subtle};
	${({ theme }) => theme.fonts.text.text4};
`;

export const AuctionTagsContainer = styled.div`
	display: flex;
	align-self: stretch;
	flex-wrap: wrap;
	gap: ${({ theme }) => theme.spacings.xxxsmall};
`;

export const WinningBannerDeliveryText = styled.span`
	${({ theme }) => theme.fonts.text.text5};
	color: ${({ theme }) => theme.colors.text.brand.enabled};
`;

export const DescriptionWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

export const SectionTitle = styled.span`
	${({ theme }) => theme.fonts.text.text1};
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const DescriptionItemsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacings.xxsmall};
`;

export const DescriptionItem = styled.div`
	display: flex;
	align-items: center;
	align-self: stretch;
	gap: ${({ theme }) => theme.spacings.xxsmall};
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const DescriptionItemTitle = styled.span`
	${({ theme }) => theme.fonts.text.text4};
`;

export const DescriptionItemValue = styled.span`
	${({ theme }) => theme.fonts.text.text5};
`;

export const ShippingDetailsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacings.small};
`;

export const ShippingDetailsText = styled.span`
	${({ theme }) => theme.fonts.text.text3};
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const ButtonWrapper = styled.div`
	display: flex;
	align-self: flex-end;
	align-items: center;

	${({ theme }) => theme.breakpoints.queries.below.mobile} {
		position: fixed;
		display: grid;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 10;
		padding: ${({ theme }) => `${theme.spacings.xsmall} ${theme.spacings.small}`};
		background: ${({ theme }) => theme.colors.backgrounds.main.translucent};
		border-top: ${({ theme }) => `1px solid ${theme.colors.borders.main.divider}`};
		backdrop-filter: blur(2px);
	}
`;
